import ServiceCRUD from '../../../services/ServiceCRUDNEWCHANNEL';

class ChannelService extends ServiceCRUD {
  constructor() {
    super('configurations/channels');
  }
}

export default new ChannelService();
